import "esbuild-css-modules-plugin-ns-css:src/js/components/colorButton/colorButton.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/components/colorButton/colorButton.module.css:injector.js";
export default new Proxy({
  "buttonContainer": "colorButton-module__buttonContainer_oDuvrW__1100",
  "buttonText": "colorButton-module__buttonText_oDuvrW__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      